import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import Button from "components/Button";
import { Board, TitleArea, Title, PageTop } from "components/LayoutParts";
import Loading from "components/Loading";
import UserModal, { UserModalConfig } from "components/UserModal";
import { sortDirection } from "constants/direction";
import { useSwr } from "hooks/useSwr";
import DataTable from "pages/PitPort/Property/DataTable";
import ActionArea from "pages/PitPort/Property/DataTable/ActionArea";
import {
  displayPropertyFilterStatus,
  DISPLAY_PROPERTY_FILTER_KEY,
} from "pages/PitPort/Property/DataTable/displayFilterProperty";
import { jumpUpToElement } from "utils/animationUtils";
import { formatQueryParams } from "utils/stringUtils";

// パーツ定義
const CreateWrap = styled.div`
  display: flex;
  flex: auto;
  justify-content: flex-end;
`;

// 本体
const Property = () => {
  const [originList, setOriginList] = useState<Property[]>([]);
  const [currentPageIndex, setCurrentPageIndex] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [sortOption, setSortOption] = useState<SortOption<SortByPitPortProperty>>({
    sortByColumn: "id",
    direction: sortDirection.desc,
  });
  const [searchKeyword, setSearchKeyword] = useState("");
  const [selectedFilter, setSelectedFilter] = useState<string[]>(displayPropertyFilterStatus());
  const [isModalShow, setIsModalShow] = useState(false);
  const hideModal = () => setIsModalShow(false);
  const showModal = () => setIsModalShow(true);

  const userModalConfig: UserModalConfig = {
    onClickOutside: hideModal,
    subtitle: "送信に失敗しました",
    main: {
      buttonType: "secondary",
      onClick: hideModal,
      label: "閉じる",
    },
    errorMessage: "時間をおいてもう一度お試しください",
  };

  const navigate = useNavigate();
  const navCreateProperty = () => navigate("/pit_port/property/create");

  const onFilterButtonClick = (status: string[]) => {
    setSelectedFilter(status);
    localStorage.setItem(DISPLAY_PROPERTY_FILTER_KEY, JSON.stringify(status));
  };

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentPageIndex(1);
    setSearchKeyword(e.target.value);
  };

  const { data, error } = useSwr<PitPortPropertiesResponse>(
    `/property?${formatQueryParams({
      pageIndex: currentPageIndex,
      pageSize: 100,
      status: selectedFilter,
      orderBy: sortOption.sortByColumn,
      orderType: sortOption.direction,
      keyword: searchKeyword,
    })}`
  );

  useEffect(() => {
    jumpUpToElement("page-top");
    if (error) {
      showModal();
      return;
    }
    if (!data) return;
    setTotalPages(data.totalPages);
    setOriginList(data.data);
  }, [data, error]);

  return (
    <>
      <Board>
        <PageTop />
        <TitleArea>
          <Title>駐車場</Title>
          <CreateWrap>
            <Button type="primary" onClick={navCreateProperty} label="駐車場を追加" width="160px" />
          </CreateWrap>
        </TitleArea>
        <ActionArea
          searchKeyword={searchKeyword}
          selectedFilter={selectedFilter}
          onSearchChange={onSearchChange}
          onFilterButtonClick={onFilterButtonClick}
        />
        {data ? (
          <DataTable
            propertyList={originList}
            totalPages={totalPages}
            pageIndex={currentPageIndex}
            sortOption={sortOption}
            setPageIndex={setCurrentPageIndex}
            setSortOption={setSortOption}
          />
        ) : (
          <Loading />
        )}
      </Board>
      <UserModal isVisible={isModalShow} config={userModalConfig}></UserModal>
    </>
  );
};

export default Property;
